export default {
    accessToken: process.env.ROLLBAR_CLIENT_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: JSON.parse(process.env.ROLLBAR_ENABLED),
    payload: {
        environment: process.env.NODE_ENV,
        client: {
            javascript: {
                code_version: process.env.REVISION,
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/rollbar/index.js